<div class="container-fluid" *ngIf="event">
  <div class="form-horizontal" wl-ng-models-valid (onValidChange)="handleFormValidChanged($event)">
    <h3>
      {{ 'events.settings.registration-settings.title' | translate | titlecase }}
      <span>
        <a href="https://support.weblinkinternational.com/hc/en-us/articles/235638608-Event-Settings-Registration-Settings" target="_blank">
          <img
            src="/assets/img/help.png"
            title="{{ 'events.settings.registration-settings.registration-settings-title-help' | translate }}"
            class="wc-help-icon"
          />
        </a>
      </span>
    </h3>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.event-status' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.DisableRegistration" />
              {{ 'events.settings.registration-settings.disable-registration' | translate | titlecase }}</label
            >
          </div>
          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.Closed" />
              {{ 'events.settings.registration-settings.hide-event-on-calendar' | translate | titlecase }}</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">Public Registration End Date</label>
      <div class="col-sm-9 col-md-10">
        <div class="input-group">
          <span class="input-group-addon">
            <input type="checkbox" [(ngModel)]="event.UsePublicRegistrationEndDate" />
          </span>
          <wl-date-selector
            [disabled]="!event.UsePublicRegistrationEndDate"
            class="input-group"
            id="event-registration-setting-public-registration-end-date"
            [(ngModel)]="event.PublicRegistrationEndDateUtc"
          ></wl-date-selector>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label">{{ 'events.settings.registration-settings.entity-label' | translate | titlecase }}</div>
      <div class="col-sm-9 col-md-10">
        <select class="form-control" [(ngModel)]="event.EntityId">
          <option value="0">{{ 'common.none' | translate | titlecase }}</option>
          <option *ngFor="let entity of entities" [value]="entity.EntityID">
            {{ entity.Descr }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label">
        {{ 'events.settings.registration-settings.payment-methods' | translate | titlecase }}
      </div>
      <div class="col-sm-9 col-md-10">
        <wl-event-settings-payment-methods (onPaymentMethodsSaved)="paymentMethodsSaved($event)"></wl-event-settings-payment-methods>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.event-assigned-to' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <wl-user-selector
          noneText="{{ 'events.settings.registration-settings.select-a-user-placeholder' | translate | titlecase }}"
          [(ngModel)]="event.AssignedTo"
          (selectedUserChanged)="selectedAssignedToUserChangedHandler($event, notifyEmail)"
        ></wl-user-selector>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.email-notifications-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <div class="form-group">
          <div class="col-sm-3 col-lg-2">
            <button
              app-add-button
              class="btn btn-primary"
              [label]="'events.settings.general.component.new-email-notifications-label' | translate | titlecase"
              (onClick)="newNotificationEmail()"
            ></button>
          </div>
          <div class="col-sm-9 col-lg-10"></div>
        </div>
        <div class="form-group" *ngFor="let notifyEmail of event.EventSignUpNotificationEmails">
          <div class="form-group">
            <div class="col-sm-3">
              {{ 'common.personal-information.email' | translate | titlecase }}
            </div>
            <div class="col-sm-6">
              <input type="email" class="form-control" [(ngModel)]="notifyEmail.Email" />
            </div>
            <div class="col-sm-3">
              <button pButton type="button" class="btn btn-danger" (click)="removeNotificationEmail(notifyEmail)">
                <span class="pi pi-trash"></span>
                {{ 'common.remove' | translate | titlecase }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-3">
              {{ 'events.settings.general.component.email-notification-user-label' | translate | titlecase }}
            </div>
            <div class="col-sm-6">
              <wl-user-selector
                [(ngModel)]="notifyEmail.UserNum"
                (selectedUserChanged)="selectedNotifyUserChangedHandler($event, notifyEmail)"
              ></wl-user-selector>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-3">
              {{ 'common.personal-information.first-name' | translate | titlecase }}
            </div>
            <div class="col-sm-6">
              <input type="text" class="form-control" [(ngModel)]="notifyEmail.FirstName" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-3">
              {{ 'common.personal-information.last-name' | translate | titlecase }}
            </div>
            <div class="col-sm-6">
              <input type="text" class="form-control" [(ngModel)]="notifyEmail.LastName" />
            </div>
          </div>

          <hr />
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.registration-settings.event-event-confirmation-email-from-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input type="text" class="form-control" [(ngModel)]="event.Email" />
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <label>
          <input type="checkbox" [(ngModel)]="event.EnableAttendeeConfirmations" />
          {{ 'events.settings.registration-settings.enable-confirmation-email-to-attendees-label' | translate }}
        </label>
      </div>
    </div>
    <div class="row">
      <label class="col-sm-3 col-md-2 control-label"></label>
      <div class="col-sm-9 col-md-10 text-right">
        <button
          pButton
          type="button"
          class="btn btn-default"
          icon="pi pi-eye"
          [label]="'common.preview' | translate | titlecase"
          (click)="previewConfirmationMessage()"
          [disabled]="loadingConfirmationMessagePreview"
        >
          <wl-busy [show]="loadingConfirmationMessagePreview"></wl-busy>
        </button>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.confirmation-message' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10" *ngIf="showEditor">
        <span class="pi pi-question-circle"></span>
        <wl-wysiwyg-editor [(ngModel)]="event.ConfirmationMessage" name="regEditor" [emailContent]="true" [editorName]="'regEditor'"></wl-wysiwyg-editor>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-3 col-md-2 control-label hidden-xs">
        {{ 'events.settings.registration-settings.attendees' | translate | titlecase }}
      </div>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-max-attendees">{{
              'events.settings.registration-settings.maximum-attendees' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-max-attendees" [(ngModel)]="event.MaxAttendees" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-min-attendees">{{
              'events.settings.registration-settings.minimum-attendees' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-min-attendees" [(ngModel)]="event.MinAttendees" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-min-attendees-date">{{
              'events.settings.registration-settings.min-attendees-action-date' | translate | titlecase
            }}</label>
            <div class="col-sm-6">
              <wl-date-selector
                id="event-registration-setting-min-attendees-date"
                [(ngModel)]="event.MinAttendeesActionDate"
              ></wl-date-selector>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-attendee-goal">{{
              'events.settings.registration-settings.attendee-goal' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-attendee-goal" [(ngModel)]="event.AttendeeGoal" />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-5 col-md-4 col-lg-3" for="event-registration-setting-sales-goal">{{
              'events.settings.registration-settings.sales-goal' | translate | titlecase
            }}</label>
            <div class="col-sm-3">
              <input type="number" class="form-control" id="event-registration-setting-sales-goal" [(ngModel)]="event.SalesGoal" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{
        'events.settings.registration-settings.details-page' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <label
            ><input type="checkbox" [(ngModel)]="showSendQuestions" />
            {{ 'events.settings.registration-settings.show-send-questions' | translate | titlecase }}</label
          >
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSendQuestions">
            {{ 'events.settings.registration-settings.send-questions-label' | translate | titlecase }}
            <input type="email" class="form-control" [(ngModel)]="event.SendQuestionsToEmail" [required]="showSendQuestions" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showSpecialDetailsPageURL" />
              {{ 'events.settings.registration-settings.show-special-details-page-url' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSpecialDetailsPageURL">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.SpecialDetailsPageURL" [required]="showSpecialDetailsPageURL" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showSpecialRegistrationUrl" />
              {{ 'events.settings.registration-settings.show-special-registration-url' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showSpecialRegistrationUrl">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.SpecialRegistrationUrl" [required]="showSpecialRegistrationUrl" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showRelatedWebsite" />
              {{ 'events.settings.registration-settings.show-related-website' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showRelatedWebsite">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.RelatedWebsite" [required]="showRelatedWebsite" />
          </p>

          <p>
            <label
              ><input type="checkbox" [(ngModel)]="event.ShowMap" />
              {{ 'events.settings.registration-settings.show-map' | translate | titlecase }}</label
            >
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showOverrideMapLink" />
              {{ 'events.settings.registration-settings.show-override-map-link' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showOverrideMapLink">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.MapLink" [required]="showOverrideMapLink" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="showWeatherLink" />
              {{ 'events.settings.registration-settings.show-weather-link' | translate | titlecase }}</label
            >
          </div>
          <p class="wc-event-setting-cb-sub-item" [hidden]="!showWeatherLink">
            {{ 'events.settings.registration-settings.enter-url-label' | translate | titlecase }}
            <input type="url" class="form-control" [(ngModel)]="event.WeatherLink" [required]="showWeatherLink" />
          </p>

          <div>
            <label
              ><input type="checkbox" [(ngModel)]="event.ShowAttendeeDetail" />
              {{ 'events.settings.registration-settings.show-attendee-detail' | translate | titlecase }}</label
            >
          </div>
          <div class="wc-event-setting-cb-sub-item" [hidden]="!event.ShowAttendeeDetail">
            {{ 'events.settings.registration-settings.after' | translate }}
            <input type="number" width="9" [(ngModel)]="event.AttendeeDetailThreshold" />
            {{ 'events.settings.registration-settings.attendees-have-registered' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-3 col-md-2 control-label">{{ 'events.settings.registration-settings.sharing' | translate | titlecase }}</label>
      <div class="col-sm-9 col-md-10">
        <div class="form-control-static">
          <label
            ><input type="checkbox" [(ngModel)]="event.ShareEnabled" />
            {{ 'events.settings.registration-settings.enable-sharing' | translate | titlecase }}</label
          >
          <h4>
            {{ 'events.settings.registration-settings.instructions' | translate | titlecase }}
          </h4>
          <div>
            {{ 'events.settings.registration-settings.instruction-description' | translate }}
          </div>
          <div>
            <textarea
              class="form-control"
              rows="5"
              type="text"
              [(ngModel)]="event.ShareInstructions"
              placeholder="{{ 'events.settings.registration-settings.instruction-placeholder' | translate }}"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-back-to-top></app-back-to-top>
</div>
